import React, { useState } from "react";
import { Link } from "react-router-dom";
import TopButton from "components/topbutton/TopButton";
import "styles/scss/organization.scss";

function Organization() {
  const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
  const [isVisionDropdownOpen, setIsVisionDropdownOpen] = useState(false);

    const [openIndex, setOpenIndex] = useState(0); // 기본값을 0으로 설정해서 '재경부'가 열리도록 함
  
    const toggleAccordion = (index) => {
      setOpenIndex(openIndex === index ? null : index); // 클릭한 항목이 이미 열려있다면 닫기, 아니면 열기
    };
  return (
    <>
      <div>
      <TopButton />
      
        <div className="infor-background">
          <h1>회사 소개</h1>
          <p>[ 대표이사 소개 / 비전 / 연혁 / 조직도 ]</p>

        {/* 브레드크럼 */}
        <div className="breadcrumb-box container">
        <nav className="breadcrumb">
              <ul>
                  <li className="home-icon">
                  <Link to="/">
                      <span className="home"></span>
                  </Link>
                  </li>                  
                  <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                  회사소개
                  <span className="dropdown-icon">
                  {isCompanyDropdownOpen ? "▲" : "▼"}
                  </span>
                  {isCompanyDropdownOpen && (
                      <ul className="dropdown-menu">
                      <li>
                          <Link to="/about">회사소개</Link>
                      </li>
                      <li>
                          <Link to="/business">비즈니스</Link>
                      </li>
                      <li>
                          <Link to="/news">N소식</Link>
                      </li>
                      <li>
                          <Link to="/recruitment">인재채용</Link>
                      </li>
                      </ul>
                  )}
                  </li>                  
                  <li className="dropdown" onClick={() => setIsVisionDropdownOpen(!isVisionDropdownOpen)}>
                  조직도
                  <span className="dropdown-icon">
                  {isVisionDropdownOpen ? "▲" : "▼"}
                  </span>
                  {isVisionDropdownOpen && (
                      <ul className="dropdown-menu">
                      <li>
                          <Link to="/about">비전,연혁</Link>
                      </li>
                      <li>
                          <Link to="/about/organization/:aboutId">조직도</Link>
                      </li>
                      </ul>
                  )}
                  </li>
              </ul>
              </nav>

          <div className="mobile">
          <ul>
                <li className="home-icon">
                <Link to="/">
                    <span className="home"></span>
                </Link>
                </li>
                <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                회사소개
                <span className="dropdown-icon">
                {isCompanyDropdownOpen ? "▲" : "▼"}
                </span>
                {isCompanyDropdownOpen && (
                    <ul className="dropdown-menu">
                    <li>
                        <Link to="/about">회사소개</Link>
                    </li>
                    <li>
                        <Link to="/business">비즈니스</Link>
                    </li>
                    <li>
                        <Link to="/news">N소식</Link>
                    </li>
                    <li>
                        <Link to="/recruitment">인재채용</Link>
                    </li>
                    </ul>
                )}
                </li>
                <li className="dropdown" onClick={() => setIsVisionDropdownOpen(!isVisionDropdownOpen)}>
                조직도
                <span className="dropdown-icon">
                {isVisionDropdownOpen ? "▲" : "▼"}
                </span>
                {isVisionDropdownOpen && (
                    <ul className="dropdown-menu">
                    <li>
                        <Link to="/about">비전,연혁</Link>
                    </li>
                    <li>
                        <Link to="/about/organization/:aboutId">조직도</Link>
                    </li>
                    </ul>
                )}
                </li>
              </ul>
          </div>
          </div>
        </div>

        <div>
          <ul className="titAndCeo">

            <li className="organization-chart">
              <h2>조직도</h2>
              <p>" 도전과 성장을 위한 조직 "</p>
              <div className="red-box-group">
                <div className="red-box">
                  <span>의장</span>
                </div>
                <div className="red-box">
                  <span>대표이사</span>
                </div>
                <div className="gray-line"></div>
                  {/* 조직도 수정 2025.03.28 시작 ----------*/}
                  {/* 전략기획부*/}
                <ul className="sb-team">
                  <li className="sb-team-li">
                      <span className="mobile-line">기술연구소</span>
                  </li>

                  {/* SI사업 /클라우드 사업 외 */}
                  <li className="sb-team-li mobile-line box-SI">
                      <ul className="box-SI-ul">
                        <li className="box-SI-li">ICT 사업부</li>
                        <li className="box-SI-li">미래개발부</li>
                        <li className="box-SI-li">클라우드사업부</li>
                      </ul>
                  </li>

                  {/* 회선사업 / 스마트기기,테크센터 사업*/}
                  <li className="sb-team-li mobile-line box-tech">
                      <ul className="box-SI-ul">
                        <li className="box-SI-li line-left">테크센터</li>
                      </ul>
                  </li>
                  {/* 영업부 */}
                  <li className="sb-team-li">
                    <span>영업부</span>
                  </li>
                  {/* 재경부 */}
                  <li className="sb-team-li">
                    <span>재경부</span>
                  </li>
                </ul>
              {/* 조직도 수정 2025.03.28 끝 ----------*/}
              </div>

              <div className="team-ul">
                <div className="team-tit">
                    <p> 직무소개 및 직무에 필요한 역량 </p>
                  </div>
                  {/* 아코디언 리스트 */}
                  {teamData.map((item, index) => (
                    <div key={index} className="accordion-item">
                        <div 
                          className={`accordion-question  ${openIndex === index ? "active" : ""}`} 
                          onClick={() => toggleAccordion(index)}
                        >
                        {item.question}
                      </div>
                      {openIndex === index && (
                        <div className="accordion-answer ">{item.answer}</div>
                      )}
                       </div>
                ))}
              </div>
            </li>


            
          </ul>
        </div>
      </div>
    </>
  );
}

export default  Organization;


const teamData = [
  { question: (       
      <div className="question-flex">
        <span className="Strategic-icon"></span>
        <span>기술연구소</span>
      </div>
    ),
    answer: (
      <div className="team-box-txt">
        <div className="h2-box">
        <h2><span className="red">Q.</span> 현재 담당하고 계신 직무에 대해 소개해주세요.</h2>
        </div>
        <p>
        ㈜엔정보기술의 미래 가치 사업에 대한 고민을 통해 만들어진 조직입니다.
        이에 전통적인 사업 분야(SI 등)에 대한 신기술 접목부분에 대한 기획, 업무 지원을 중심으로, 융합기술에 대한 기획, 국가 R&D 참여와 운영, 연구소 운영지원까지를 주업무 영역으로 하고 있습니다.
        <br></br>
        <span className="p-highlight">[주 사업분야]</span> <br></br>
        융복합 분야(산업안전, 환경, 기반 기술 개발, 보건복지 분야 등)의 국가 R&D 수행, 생활레이더(60GHz ~ 77GHz, 24GHz 대역) 기술 기반의 스마트 시티 사업, 레독스 기술을 기반의 수자원 관리/활용 솔루션(운영, 장치 등) 개발/보급사업, 자회사인 ㈜굿팜즈와 함께 자체기술로 개발한 스마트팜 전주기 운영설비 보급사업 등을 유지하고 있습니다.
        이를 위해 한국과학기술정보연구원(KISTI), 한국과학기술연구원(KIST), 한국한의약진흥원(NICOM), 울산과학기술원(UNIST), 한국농수산대학교, 울산테크노파크(UTP), 국방과학벤처센터와 MOU, 기술교류 및 공동사업기획과 연구 등을 함께 하고 있습니다
        </p>
        <div className="line"></div>
        <div className="h2-box">
        <h2><span className="red">Q.</span> 해당 직무에 필요한 역량은 어떤 것이 있나요?</h2>
        </div>
        <p>
        전략기획부는 강한 지적 호기심을 바탕으로 한 명확한 목표의식과 책임감이 요구되는 조직으로, 구성원의 자율성을 최대한 보장하며, 부서 전체가 개인의 업무 범위와 책임의 한계를 독자적으로 규정하는 문화를 지향합니다.
        </p>
      </div>
    )
  },  
   { question: (
    <div className="question-flex">
      <span className="it-icon"></span>
      <span>ICT사업부</span>
    </div>
  ),
    answer: (
      <div className="team-box-txt">
        <div className="h2-box">
        <h2><span className="red">Q.</span> 현재 담당하고 계신 직무에 대해 소개해주세요.</h2>
        </div>
        <p>
        ICT사업부는 고객사의 정보자산, IT 인프라, 클라우드에 관련된 컨설팅/운영/관리 서비스를 전통적으로 수행하며 본 사업부 목표로는 고객사의 IT 운영 효율성, 고객 맞춤형 클라우드 제공, 최신 기술 적용을 통한 비즈니스 경쟁력 강화를 목표로 꾸준히 노력하고 있습니다. <br></br>

          <span className="p-highlight">- IT 인프라</span> <br></br>
            전산시스템의 전반적인 운영[서버, 프라이빗 클라우드(VMware, OpenStack), 스토리지, 네트워크, 보안시스템, 부대시설 등]과 설계/구축을 수행하며, 지속적인 점검 및 모니터링을 통해 선재적 장애 예방 활동을 수행 합니다.
            <br></br>
          <span className="p-highlight">- 클라우드</span> <br></br>
            현 NHN클라우드 MSP사로 기업 및 공공기관의 클라우드 전환시 고객요구 분석을 통해 맞춤형 클라우드 컨설팅(퍼블릭 클라우드, DevOps, Kubernetes, Docker 환경 구축)을 지원하며 IT 인프라의 유연성과 효율성을 극대화하기 위해 다양한 클라우드 서비스와 기술을 제공합니다.
        </p>
        <div className="line"></div>
        <div className="h2-box">
        <h2><span className="red">Q.</span> 해당 직무에 필요한 역량은 어떤 것이 있나요?</h2>
        </div>
        <p>
        ICT사업부는 IT인프라, 클라우드 두 직무에 대한 프로젝트 관리, 협업 및 최신 IT 기술 습득이 중요하며 성장 전략으로 자격증 취득, 실무 경험, 최신 기술 트렌드 학습이 필요합니다.
        <br></br>
        <span className="p-highlight">[요구역량 및 우대조건]</span> <br></br>
        1) 전공 : 전산, 통신, 정보보안전공 <br></br>
        2) Knowledge<br></br>
          - IT 인프라: 다양한 OS 운영, 가상화서버, 네트워크 및 통신, 프라이빗 클라우드, 정보보안 관련 운영 및 구축 지식 등, 관련 자격증<br></br>
          - 클라우드: 퍼블릭 클라우드 서비스, 가상서버, Docker 및 Kubernetes(K8s) , CI/CD 파이프라인, DevOps에 대한 이해와 운영 능력, 관련 자격증
          - 여러 기술의 능력도 중요하지만 업무에 대한 책임감과 끈기, 고객 및 관련 기업들과의 원활한 커뮤니케이션이 매우 중요합니다. 
        </p>
      </div>
    )
   },
    { question: (
      <div className="question-flex">
        <span className="Development-icon"></span>
        <span>미래개발부</span>
      </div>
    ),
    answer: (
      <div className="team-box-txt">
        <div className="h2-box">
        <h2><span className="red">Q.</span> 현재 담당하고 계신 직무에 대해 소개해주세요.</h2>
        </div>
        <p>
        ICT 기반의 시스템 및 응용소프트웨어 개발을 중심으로, 빅데이터 플랫폼 구축 등 최신 기술 트렌드를 반영한 다양한 프로젝트를 수행하고 있습니다. <br></br>
        특히 소방·재난안전 분야에 특화된 R&D 연구과제의 기획과 개발을 통해, 현장 중심의 실용적인 기술을 구현하고 있으며, AI 및 데이터 기반 의사결정 기술의 도입 가능성도 지속적으로 모색하고 있습니다.
        공공 및 민간 부문의 다양한 프로젝트 경험을 바탕으로, 소프트웨어 개발에 대한 높은 전문성과 기술 경쟁력을 보유하고 있습니다.
        </p>
        <div className="line"></div>
        <div className="h2-box">
        <h2><span className="red">Q.</span> 해당 직무에 필요한 역량은 어떤 것이 있나요?</h2>
        </div>
        <p>
        빠르게 변화하는 기술 환경에 유연하게 대응할 수 있는 기술 트렌드 이해력과, 문제 상황에 직면했을 때 끝까지 해결책을 찾아내려는 집요함과 논리적 사고력이 중요한 역량입니다.
        또한, 사용자 중심의 사고를 바탕으로 기존과 차별화된 창의적인 아이디어를 개발에 반영하려는 자세도 필요합니다. 협업이 잦은 업무 특성상, 원활한 커뮤니케이션과 팀워크, 그리고 개인과 팀의 목표에 대한 책임감 있는 태도가 요구됩니다.<br></br>
        <span className="p-highlight">[요구역량 및 우대조건]</span> <br></br>
        <span>기술역량</span> <br></br>
        - 주요 프로그래밍 언어 및 프레임워크에 대한 숙련도 (Java, SpringBoot, 전자정부프레임워크(eGovFrame), Python, JavaScript, React 등 다양한 언어 및 프레임워크를 활용한 개발 경험)<br></br>
              - 데이터 처리 및 저장 기술에 대한 이해 (관계형(SQL) 및 비관계형(NoSQL) 데이터베이스의 구조와 활용 방식에 대한 이해 및 설계 능력)<br></br>
              - 시스템 아키텍처 및 설계 역량 (클라우드 기반 환경에서의 MSA(Microservices Architecture), REST API 설계 등 분산 시스템 구성에 대한 이해도)<br></br>
              - 현장 중심의 개발 및 운영 기술 활용 능력 (Web과 Mobile 플랫폼을 포함한 전반적인 개발 환경 구성 능력, CI/CD 파이프라인 구축 및 운영 자동화, Docker 및 Kubernetes를 활용한 컨테이너 기반 개발 및 배포 경험)

        <br></br> <br></br> 
        1) 빠르게 변화하는 기술 흐름에 대한 민감도와 적응력 <br></br>
        2) 문제 해결을 위한 논리적 사고 및 끈기<br></br>
        3) 창의성과 사용자 중심 사고<br></br>
        4) 팀 내 협업 및 소통 역량<br></br>
        5) 전문성 강화를 위한 지속적인 학습 태도<br></br>
        </p>
      </div>
    )
  },

  { question: (
    <div className="question-flex">
      <span className="Strategic-icon"></span>
      <span>테크센터</span>
    </div>
  ),
    answer: (
      <div className="team-box-txt">
        <div className="h2-box">
          <h2><span className="red">Q.</span> 현재 담당하고 계신 직무에 대해 소개해주세요.</h2>
        </div>
        <p>
        디지털 교육화 시대의 도래에 맞춰 울산광역시 모든 학교 현장의 무선 및 디바이스 인프라 관리 부담을 줄이고 다양한 인프라 장애를 대응하는 통합유지관리 센터

        </p>
        <div className="line"></div>
        <div className="h2-box">
          <h2><span className="red">Q.</span> 해당 직무에 필요한 역량은 어떤 것이 있나요?</h2>
        </div>
        <p>
        고객(울산광역시 담당자, 각 학교별 담당자)의 니즈 충족과 문제 해결을 위해 치열하게 고민하고 서비스 정신으로 고객이 원하는 해결 방안을 도출합니다. <br></br>
        AIDT에 맞춰 무선 인프라 기술력을 높이고 각종 디바이스에 대한 이해도를 높여 안정적인 유지관리가 될 수 있도록 합니다.
        </p>
      </div>
    )
   },   
   { question: (
    <div className="question-flex">
      <span className="Planning-icon"></span>
      <span>영업부</span>
    </div>
  ),
    answer: (
      <div className="team-box-txt">
        <div className="h2-box">
        <h2><span className="red">Q.</span> 현재 담당하고 계신 직무에 대해 소개해주세요.</h2>
        </div>
        <p>
        정보통신시스템 유지보수, 네트워크 구축 및 증설 등 정보통신 관련 사업을 수주하고 원활한 사업 진행을 위해 기술영업, 제안서 작성, 사업관리 등의 업무를 수행합니다.
        </p>
        <div className="line"></div>
        <div className="h2-box">
        <h2><span className="red">Q.</span> 해당 직무에 필요한 역량은 어떤 것이 있나요?</h2>
        </div>
        <p>
        기술영업은 고객사에서 어떤 사업을 준비하는지, 어떤 문제가 있는지, 필요한 것이 무엇인지 파악하고 적절한 솔루션을 제안하는 것이 중요합니다. <br></br>의사소통, 인적 네트워크 관리 능력과 산업 및 제품의 이해가 필요합니다. 그리고 제안서 작성, 사업관리 등 문서를 작성하고 관리하기 위해 기본적인 OA 능력도 필요합니다.
        </p>
      </div>
    )
  },
    { question: (
      <div className="question-flex">
        <span className="Finance-icon"></span>
        <span>재경부</span>
      </div>
    ), 
    answer: (
      <div className="team-box-txt">
        <div className="h2-box">
        <h2><span className="red">Q.</span> 현재 담당하고 계신 직무에 대해 소개해주세요.</h2>
        </div>
        <p>
        우선 재무관리, 회계&세무, 경영지원 세 파트로 나눌 수 있습니다. 재무관리는 자금조달과 자금관리를 하고 있으며, 회계&세무 파트에서는 매입과 매출 관리, 마감 등 내부 관리 회계와 법인세 결산을, 경영지원 파트에서는 회사 전반의 관리적인 사항에 지원하고 있습니다.
        </p>
        <div className="line"></div>
        <div className="h2-box">
        <h2><span className="red">Q.</span> 해당 직무에 필요한 역량은 어떤 것이 있나요?</h2>
        </div>
        <p>
        숫자를 다루는 것이 주된 업무이기 때문에 꼼꼼함이 필요합니다. 작성하며 잘못된 부분은 없는지 세세하게 검토해야하기 때문입니다. 또, 아무래도 회사의 자산과 자원을 관리하는 부서이다 보니 내 것보다는 전체를 아우르는 마인드가 중요하다고 생각합니다.
        </p>
      </div>
    )
  },
];
